import { Code, Link } from '@apollo/orbit';
import React from 'react';

import { safeCompileMarkdown } from 'src/lib/safeCompileMarkdown';

export const LinterRuleDescriptionMarkdownRenderer = ({
  descriptionMarkdown,
}: {
  descriptionMarkdown: string;
}) => {
  return safeCompileMarkdown(descriptionMarkdown, {
    overrides: {
      code: {
        component: Code,
      },
      a: {
        component: (props) => {
          return <Link isExternal {...props} to={props.href} />;
        },
      },
    },
  });
};
